import { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import SearchIcon from "@mui/icons-material/Search";
import { Tooltip } from "@mui/material";
import Icons from "../../../../../components/icons";
import Uploadfile from "../../../../../components/uploadFiles";
import env from "../../../../../config/env";
import { useUserInfo } from "../../../../../context/user";
import { useAppServices } from "../../../../../hook/services";

const timeAgo = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const diffMs = Date.now() - date.getTime();
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (days < 1) return "Updated today";
  if (days < 7) return `Updated ${days}d ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 4) return `Updated ${weeks}w ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `Updated ${months}mo ago`;
  return `Updated ${Math.floor(days / 365)}y ago`;
};

const getFileType = (name) => {
  if (!name) return "FILE";
  const parts = name.split(".");
  return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : "FILE";
};

const SharedKnowledge = ({ onAddUrl, refreshSignal = 0 }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const profileId = userActiveLocation?.id;

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [downloadingFileId, setDownloadingFileId] = useState(null);
  const AppService = useAppServices();

  const fetchFiles = async () => {
    if (!profileId) return;
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/chat/profiles/${profileId}/files`
      );
      const list = response?.data?.data || [];
      setFiles(Array.isArray(list) ? list : []);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to load shared files"
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchFiles();
  }, [profileId, refreshSignal]);

  const handleDelete = async (fileId) => {
    if (!profileId || !userInfo?._id) return;
    try {
      await axios.delete(
        `${BASE_URL}/chat/profiles/${profileId}/files/${fileId}?user_id=${userInfo._id}`
      );
      setFiles((prev) => prev.filter((f) => f.id !== fileId));
      setSelectedItems((prev) => prev.filter((id) => id !== fileId));
      toast.success("File deleted");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to delete file");
    }
  };

  const handleDeleteSelected = async () => {
    if (selectedItems.length === 0) return;
    for (const id of selectedItems) {
      // eslint-disable-next-line no-await-in-loop
      await handleDelete(id);
    }
  };

  const handleDownloadFile = async (file_id) => {
    console.log(file_id, "file_id");

    setDownloadingFileId(file_id);
    try {
      const win = window.open(`${BASE_URL}/chat/assistants/files/download?file_id=${file_id}&isStreaming=true`, '_blank')
      // setTimeout(() => win.close(), 3000)
      setDownloadingFileId(null);
    } catch (error) {
      console.error("Error downloading file:", error.message);
      setDownloadingFileId(null);
    }
  };

  const toggleCheckbox = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const rows = files.filter((r) =>
    (r.name || "").toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <p style={{ marginBottom: "4px", fontSize: "18px" }}>
        Knowledge added here is automatically available to all agents.{" "}
        <strong>
          Best for brand guidelines, policies, and universal instructions.
        </strong>
      </p>
      <p style={{ color: "#757575", marginBottom: "20px", fontSize: "14px" }}>
        Future agents will inherit this knowledge by default.
      </p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
          marginBottom: "20px",
        }}
      >
        <div className="search_box relative">
          <input
            type="text"
            className="inputsearch !w-[740px]"
            placeholder="Search for Files"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <span className="absolute top-3 left-3">
            <SearchIcon />
          </span>
        </div>

        <div style={{ display: "flex", gap: "12px", flexShrink: 0 }}>
          <Uploadfile
            classname="filecogChatBtn"
            refreshchat={fetchFiles}
            compType="shared_knowledge"
            isSharedKnowledge
          />
          <button
            onClick={onAddUrl}
            aria-label="Add URL"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 20px",
              border: "1px solid #E5E7EB",
              borderRadius: "8px",
              background: "#fff",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            <Icons id="KBurl" />
            <span>Add URL</span>
          </button>
        </div>
      </div>

      <button
        onClick={handleDeleteSelected}
        disabled={selectedItems.length === 0}
        style={{
          backgroundColor: "#000",
          color: "#fff",
          borderRadius: "8px",
          padding: "10px 20px",
          border: "none",
          cursor: selectedItems.length === 0 ? "not-allowed" : "pointer",
          fontSize: "14px",
          marginBottom: "20px",
        }}
      >
        Delete All
      </button>

      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "#6B7280",
            fontWeight: 600,
            fontSize: "13px",
            padding: "0 16px",
            marginBottom: "8px",
          }}
        >
          <p style={{ padding: "12px 8px", width: "6%" }}></p>
          <p style={{ padding: "12px 8px", width: "22%" }}>File Name</p>
          <p style={{ padding: "12px 8px", width: "12%" }}>Type</p>
          <p style={{ padding: "12px 8px", width: "16%" }}>Last Updated</p>
          <p style={{ padding: "12px 8px", width: "14%" }}>Used By</p>
          <p style={{ padding: "12px 8px", width: "14%" }}>Uploaded By</p>
          <p style={{ padding: "12px 8px", width: "16%" }}></p>
        </div>

        {loading ? (
          <p style={{ textAlign: "center", padding: "16px" }}>Loading...</p>
        ) : rows.length > 0 ? (
          rows.map((item, index) => {
            console.log(item, "item123123");

            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#FFFFFF",
                  border: "1px solid #E5E7EB",
                  borderRadius: "4px",
                  marginBottom: "10px",
                  padding: "0 20px",
                  fontSize: "14px",
                }}
              >
                <p style={{ padding: "16px 8px", width: "6%" }}>
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(item.id)}
                    onChange={() => toggleCheckbox(item.id)}
                    style={{
                      width: "18px",
                      height: "18px",
                      accentColor: "#000",
                      cursor: "pointer",
                    }}
                  />
                </p>
                <Tooltip title={item.name} placement="top-start">
                  <p
                    style={{
                      padding: "16px 8px",
                      width: "22%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ paddingRight: "8px", display: "flex" }}>
                      <Icons id="KBfile" />
                    </span>
                    {item.name.length > 15
                      ? item.name.slice(0, 15) + "..."
                      : item.name}
                  </p>
                </Tooltip>
                <p style={{ padding: "16px 8px", width: "12%" }}>
                  {getFileType(item.name)}
                </p>
                <p style={{ padding: "16px 8px", width: "16%" }}>
                  {timeAgo(item.created_at)}
                </p>
                <p style={{ padding: "16px 8px", width: "14%" }}>
                  <span
                    style={{
                      background: "#F3F4F6",
                      color: "#374151",
                      padding: "4px 12px",
                      borderRadius: "9999px",
                      fontSize: "13px",
                    }}
                  >
                    All agents
                  </span>
                </p>

                <p
                  style={{
                    padding: "16px 8px",
                    width: "14%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >

                  {item?.user_name}
                </p>

                <p
                  style={{
                    padding: "16px 8px",
                    width: "16%",
                    paddingRight: "35px",
                    textAlign: "right",
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                  }}
                >
                  <button
                    onClick={() => handleDownloadFile(item?.id)}
                    disabled={
                      downloadingFileId !== null && downloadingFileId !== item.id
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: downloadingFileId ? "not-allowed" : "pointer",
                      width: "20px",
                      height: "20px",
                      marginRight: "8px",
                    }}
                  >
                    {downloadingFileId === item.id ? (
                      <Icons id="spinner" color="black" />
                    ) : (
                      <Icons id="downloadFile" />
                    )}
                  </button>

                  <button
                    onClick={() => handleDelete(item.id)}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <Icons id="delete" />
                  </button>
                </p>
              </div>
            )
          })
        ) : (
          <p style={{ textAlign: "center", padding: "16px" }}>No files found.</p>
        )}
      </div>
    </>
  );
};

export default SharedKnowledge;
